import { useEffect, useState } from "react";
import Loader from "../CommerceManager/component/Loader";
import { useSelector } from "react-redux";
import domain from "../reusecomponent/domain";
import {
  ErrorToastContainer,
  SuccessToastContainer,
} from "../whatsapp/function/CustomFunction";

export default function ReferralPage() {
  const [loading, setLoading] = useState(false);
  const [referral, setReferral] = useState(null);

  const Accesstoken = useSelector((state) => state.Token.value);

  useEffect(() => {
    fetchReferral();
  }, []);

  const fetchReferral = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${domain()}/gmb/referral`, {
        headers: { Authorization: `Bearer ${Accesstoken}` },
      });
      const json = await res.json();

      if (res.ok && json.status) {
        setReferral(json.data);
      } else {
        ErrorToastContainer(json.message);
      }
    } catch {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }
  };

  const copyReferralCode = () => {
    navigator.clipboard.writeText(referral.referel_code);
    SuccessToastContainer("Referral code copied!");
  };

  return (
    <div className="card p-4">
      {loading && <Loader />}

      <h5 className="mb-4">🎁 Referral Program</h5>

      {referral && (
        <>
          {/* Top section */}
          <div className="row mb-4">
            {/* Wallet Balance */}
            <div className="col-md-4">
              <div className="border rounded p-3 text-center h-100">
                <p className="text-muted mb-1">Referral Wallet Balance</p>
                <h3 className="fw-bold text-success">
                  ₹{referral.refer_balance}
                </h3>
              </div>
            </div>

            {/* Referral Code */}
            <div className="col-md-8">
              <div className="border rounded p-3 h-100">
                <p className="text-muted mb-2">Your Referral Code</p>

                <div className="d-flex align-items-center gap-3">
                  <div
                    className="border rounded px-4 py-2 fw-bold fs-5"
                    style={{ letterSpacing: "1px" }}
                  >
                    {referral.referel_code}
                  </div>

                  <button
                    className="btn btn-outline-primary"
                    onClick={copyReferralCode}
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="border rounded p-3">
            <p className="fw-semibold mb-2">How Referral Works</p>
            <p className="text-muted mb-0" style={{ whiteSpace: "pre-line" }}>
              {referral.description}
            </p>
          </div>
        </>
      )}

      {!loading && !referral && (
        <p className="text-center text-muted">No referral data found</p>
      )}
    </div>
  );
}